/**
* NGTInstaller.js
* 
* Created 2021-03
*
* @author reinier@ranj.nl
**/

import GameClock from '../../../../lib/html5-software-library/src/ranj/eng/story/framework/clock/GameClock.js';
import '../../../assets/skins/MainAssets.js'; //Import asset file(s) used by this module.
import AbstractInstaller from "../../core/application/AbstractInstaller";
import ContextEvent from "../../core/application/ContextEvent";
import MediatorMapping from "../../core/application/MediatorMapping";
import PreloadCompleteCommand from "../../core/application/PreloadCompleteCommand";
import SkinKeyRegistry from '../../core/ui/SkinKeyRegistry.js';
import InitVideoPlayerTask from "../../core/video/InitVideoPlayerTask";
import PauseVideoPlayerButtonMediator from '../../core/video/PauseVideoPlayerButtonMediator.js';
import ChatInstaller from '../chat/ChatInstaller.js';
import NGTDebugInstaller from '../debug/NGTDebugInstaller.js';
import RevisionToolInstaller from "../debug/revision/RevisionToolInstaller";
import DecisionInstaller from '../decision/DecisionInstaller.js';
import PlayDialogCommand from "../dialog/controller/PlayDialogCommand";
import NGTDialogFactory from "../dialog/NGTDialogFactory";
import NGTDialogPlayer from "../dialog/NGTDialogPlayer";
import DialogPlayerAnswerTimerMediator from "../dialog/view/DialogPlayerAnswerTimerMediator";
import DialogPlayerMediator from "../dialog/view/DialogPlayerMediator";
import DialogPlayerOptionsAndTopicsFixedButtonsMediator from "../dialog/view/DialogPlayerOptionsAndTopicsFixedButtonsMediator";
import DialogPlayerTimerMediator from "../dialog/view/DialogPlayerTimerMediator";
import EmailInstaller from "../email/EmailInstaller";
import FileInstaller from '../files/FileInstaller.js';
import LaptopInstaller from '../laptop/LaptopInstaller.js';
import InitPlaySessionTask from "../playsession/InitPlaySessionTask";
import PlaySessionModel from '../playsession/PlaySessionModel';
import ProblemLinkingInstaller from "../problemlinking/ProblemLinkingInstaller";
import PullContentInstaller from "../pull/PullContentInstaller";
import AddNPCCommand from "../scenario/controller/AddNPCCommand";
import InitializeScenariosCommand from '../scenario/controller/InitializeScenariosCommand';
import PlayScenarioCommand from "../scenario/controller/PlayScenarioCommand";
import ScenarioCommandEvent from '../scenario/controller/ScenarioCommandEvent';
import NGTScenarioPlayer from "../scenario/NGTScenarioPlayer";
import NGTStoryFactory from "../scenario/NGTStoryFactory";
import NPCModel from "../scenario/NPCModel";
import ScenarioLibrary from "../scenario/ScenarioLibrary";
import ScenarioPlayerEvent from "../scenario/ScenarioPlayerEvent";
import SmartphoneInstaller from "../smartphone/SmartphoneInstaller";
import PlayVideoCommand from "../videoplayer/PlayVideoCommand";
import VideoPlayerMediator from "../videoplayer/VideoPlayerMediator";
import WorkspaceInstaller from '../workspace/WorkspaceInstaller.js';
import NGTAssetLocator from "./NGTAssetLocator";
import NGTVariableManager from "./NGTVariableManager";
import StartGameCommand from './StartGameCommand';
import HandlebarsInstaller from '../third-party/handlebars/HandlebarsInstaller';

//Note 20210322: due to recent overhaul, scaffolding tools will not work until they are updated!

// Generated imports (Don't remove the "#ImportPointer" comment or import generation won't work)
// #ImportPointer
// End of generated imports

export default class NGTInstaller extends AbstractInstaller {

        /**
         * @param {infuse.Injector} injector 
         * @param {soma.Commands} commands 
         * @param {MediatorMapping} mediatorMap 
         */
        constructor(injector, commands, mediatorMap) {
                super(injector, commands, mediatorMap);

                // NGT basics
                commands.add(ContextEvent.START_GAME, StartGameCommand);
                commands.add(ContextEvent.PRELOAD_COMPLETE, PreloadCompleteCommand);
                injector.mapClass("assetLocator", NGTAssetLocator, true);

                // Scenario playing
                injector.mapClass("gameClock", GameClock, true);
                injector.mapClass("variableManager", NGTVariableManager, true);

                injector.mapClass("scenarioPlayer", NGTScenarioPlayer, false);
                injector.mapClass("scenarioLibrary", ScenarioLibrary, true);
                injector.mapClass("storyFactory", NGTStoryFactory, true);
                commands.add(ScenarioCommandEvent.PLAY_SCENARIO, PlayScenarioCommand);
                commands.add(ScenarioCommandEvent.INITIALIZE_SCENARIOS, InitializeScenariosCommand);
                injector.mapClass("playSessionModel", PlaySessionModel, true);

                this._addStartupTask(InitPlaySessionTask, "initPlaySession");

                injector.mapClass("npcModel", NPCModel, true);
                commands.add(ScenarioPlayerEvent.NPC_AVAILABLE, AddNPCCommand);

                // Dialog playing
                injector.mapClass("dialogFactory", NGTDialogFactory, true);
                injector.mapClass("dialogPlayer", NGTDialogPlayer, false);//NB: not a singleton!
                commands.add(ScenarioPlayerEvent.PUSH_DIALOG_AVAILABLE, PlayDialogCommand);
                SkinKeyRegistry.DIALOG_SCREEN_SKIN = this._mapMediator(DialogPlayerMediator, lib.MainAssets.DialogScreenSkin);
                SkinKeyRegistry.DIALOG_OPTIONS_SKIN = this._mapMediator(DialogPlayerOptionsAndTopicsFixedButtonsMediator);
                SkinKeyRegistry.DIALOG_TIMER_SKIN = this._mapMediator(DialogPlayerTimerMediator);
                SkinKeyRegistry.DIALOG_ANSWER_TIMER_SKIN = this._mapMediator(DialogPlayerAnswerTimerMediator);

                // Video playing
                commands.add(ScenarioPlayerEvent.MOVIE_AVAILABLE, PlayVideoCommand);
                this._addStartupTask(InitVideoPlayerTask, "initVideoPlayer", 1);
                SkinKeyRegistry.VIDEO_PLAYER_SKIN = this._mapMediator(VideoPlayerMediator, createjs.Container);
                SkinKeyRegistry.PAUSE_VIDEO_PLAYER_BUTTON_SKIN = this._mapMediator(PauseVideoPlayerButtonMediator, createjs.Container);

                // Sub installers
                this._install(ProblemLinkingInstaller);
                this._install(PullContentInstaller);
                this._install(EmailInstaller);
                this._install(FileInstaller);
                this._install(ChatInstaller);
                this._install(SmartphoneInstaller);
                this._install(LaptopInstaller);
                this._install(RevisionToolInstaller);
                this._install(WorkspaceInstaller);
                this._install(DecisionInstaller);
                this._install(NGTDebugInstaller);
                this._install(HandlebarsInstaller);

                // Generated code (Don't remove the "#Pointer" comment or code generation won't work)
                // #Pointer
                // End of scaffolding
        }
}